import StandTypeFilterField from "./stand-type-filter-field";
import StandCommentsFilterField from "./stand-comments-filter-field";


const StandFields = {
    TypeFilter     : StandTypeFilterField,
    CommentsFilter : StandCommentsFilterField
}

export default StandFields;
